var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardCard',{attrs:{"width":_vm.width,"dataDisplay":_vm.dataDisplay,"color":_vm.color,"icons":_vm.icons,"title":_vm.title,"load_url":_vm.load_url}})}
var staticRenderFns = []

export { render, staticRenderFns }